export const ADMINSTRATIVE_FEE = 4;
export const PER_GAME_FEE = 5;
export const WEEKS_IN_SEASON = 14;
export const ENTRY_FEE = PER_GAME_FEE * WEEKS_IN_SEASON;
export const SEASON_ENTRY_FEE = ENTRY_FEE + ADMINSTRATIVE_FEE;